export const PLAN_MODULES = {
  PRIMARY_DEFINITION: 'primary_definition',
  COVERAGE: 'coverage',
  ACCOUNT_FOUNDING: 'account_founding',
  PAYMENT_RULES: 'payment_rules',
  ACTIVITY_LOG: 'activity_log',
  ELIGIBLE_SERVICES: 'eligible_services',
  FINAL_SETUP: 'final_setup',
  DANGER_ZONE: 'danger_zone',
};
